import React, { Suspense } from "react";
import { BrowserRouter } from "react-router-dom";
import { TelemetryContextProvider } from "@smb/web-telemetry";

import { FluentProvider } from "../shared/fluent-provider/FluentProvider";
import { ServiceContextProvider } from "../components/acs-service-provider/ServiceContextProvider";
import { RegionalApolloProvider } from "../apollo/regional-apollo-provider";
import { PlatformTypeProvider } from "../components/platform-type-provider/PlatformTypeProvider";
import { InstrumentationKeyProvider } from "../components/telemetry/InstrumentationKeyProvider";
import { AuthProvider } from "../components/auth-provider/AuthProvider";
import { LocalizationProvider } from "../components/localization-provider/LocalizationProvider";
import { AppLoadingScreen } from "../components/app-loading-screen/AppLoadingScreen";

import { RouteSwitcher } from "./RouteSwitcher";

export const App: React.FC = () => {
  return (
    <LocalizationProvider>
      <TelemetryContextProvider>
        <PlatformTypeProvider>
          <FluentProvider>
            <BrowserRouter>
              <AuthProvider>
                <RegionalApolloProvider>
                  <InstrumentationKeyProvider>
                    <ServiceContextProvider>
                      <Suspense fallback={<AppLoadingScreen />}>
                        <RouteSwitcher />
                      </Suspense>
                    </ServiceContextProvider>
                  </InstrumentationKeyProvider>
                </RegionalApolloProvider>
              </AuthProvider>
            </BrowserRouter>
          </FluentProvider>
        </PlatformTypeProvider>
      </TelemetryContextProvider>
    </LocalizationProvider>
  );
};
